import { render, staticRenderFns } from "./CbsRecordForm.vue?vue&type=template&id=15c43bc8&scoped=true"
import script from "./CbsRecordForm.vue?vue&type=script&lang=js"
export * from "./CbsRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c43bc8",
  null
  
)

export default component.exports